export const stat = {
  table: {
    field: {
      src: 'Sumber',
      dst: 'Tujuan',
      date: 'Tanggal',
      time: 'Waktu',
      duration: 'Durasi',
      type_answer: 'Jenis Jawaban',
      sip_account: 'akun SIP',
      contact: 'Kontak',
      recording: 'Rekaman'
    }
  },

  common: {
    field: {
      date: 'Tanggal',
      internal: 'Internal',
      external: 'Eksternal',
      incoming: 'Incoming',
      outgoing: 'Outgoing',
      total: 'Total',
      acd: 'ACD',
      asr: 'ASR'
    },

    block: {
      main: 'Panggilan',
      asr: 'ASR',
      acd: 'ACD'
    },

    filter: {
      group_by: {
        title: 'Kelompok by',
        values: {
          date: 'Tanggal',
          contact: 'Kontak',
          sip_account: 'akun SIP',
          destination: 'Tujuan',
          type: 'Jenis'
        }
      }
    }
  },

  detailed: {
    field: {
      type: 'Jenis',
      destination: 'Tujuan'
    }
  },

  call_type: {
    incoming: 'Incoming',
    outgoing: 'Outgoing'
  },

  call_destination: {
    internal: 'Internal',
    external: 'Eksternal'
  },

  type_answer: {
    ANSWERED: 'Terjawab',
    FAILED: 'Gagal',
    CANCELED: 'Dibatalkan',
    REJECTED: 'Ditolak',
    NO_ANSWER: 'Tidak ada jawaban'
  },

  contact_not_fixed: 'Kontak tidak terfix',
  sip_not_fixed: 'Akun SIP tidak terfix',
  

  errors: {
    date: 'Invalid date period',
    date_period: 'Jangka waktu yang ditentukan tidak boleh melebihi 7 hari'
  },

  tooltips: {
    period: 'Jangka waktu yang ditentukan tidak boleh lebih dari 7 hari',
    one_sip_account: 'Akun SIP tetap pertama&nbsp;ditampilkan',
    sip_not_fixed: 'Ini mungkin panggilan ke titik masuk dalam skema routing PBX atau situasi lain di mana akun operator tidak dapat difiksasi.'
  }
};